export default __webpack_public_path__ + "static/media/checked_print_pdc.7be790fc.svg";